import {
  PieChartOutlined,
  CheckCircleFilled,
  CloseCircleFilled,
} from "@ant-design/icons";
import { useEffect, useState } from "react";
import DataTable from "../../../../Components/DataTable/DataTable";
import { toJalaali } from "jalaali-js";
import { Link } from "react-router-dom";
import api from "../../../../api/api";
import { message } from "antd";

const VoteReport = () => {
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({});

  useEffect(() => loadData(1, 100), []);

  const columns = [
    {
      title: "نام",
      dataIndex: "firstname",
    },
    {
      title: "نام خانوادگی",
      dataIndex: "lastname",
      searchable: true,
      width: 130,
      onHeaderCell: () => ({ style: { whiteSpace: "nowrap" } }),
    },
    {
      title: "شماره همراه",
      dataIndex: "username",
      searchable: true,
    },
    {
      title: "نقشه جدید",
      dataIndex: "renewal",
      width: 110,
      onHeaderCell: () => ({ style: { whiteSpace: "nowrap" } }),
      render: (_, rec) => {
        return rec.renewal ? (
          <Link to={`/user-roadmap/${rec.renewal}`}>
            <CheckCircleFilled style={{ color: "green", fontSize: 18 }} />
          </Link>
        ) : (
          <CloseCircleFilled style={{ color: "red", fontSize: 18 }} />
        );
      },
    },
    {
      title: "محصول",
      dataIndex: "product",
      filterMultiple: false,
      filters: [
        { text: "نقشه راه روان‌شناسی", value: "roadmap-psychology" },
        { text: "نقشه راه لایف کوچ", value: "roadmap-3" },
        { text: "نقشه راه عمران", value: "roadmap-civil" },
      ],
      render: (product) => product || "-",
    },
    {
      title: "نظر",
      dataIndex: "vote",
    },
    {
      title: "تاریخ",
      dataIndex: "createdAt",
      render: (record) => {
        try {
          const date = new Date(record);

          const jalali = toJalaali(
            date.getFullYear(),
            date.getMonth() + 1,
            date.getDate(),
          );
          return (
            <span dir="ltr">
              {jalali.jy}-{jalali.jm}-{jalali.jd}{" "}
              {date.toLocaleTimeString("eo", { hour12: false })}
            </span>
          );
        } catch (error) {
          return "خطا";
        }
      },
    },
  ];

  const loadData = (page = 1, pageSize = 100, filters = {}) => {
    api
      .get("/roadmaps-vote", {
        params: { page, pageSize, ...filters },
      })
      .then((res) => {
        setPagination(res.data.pagination);
        setData(
          res.data.results.map((e) => ({
            id: e.id,
            vote: e.vote,
            product: e.productTitle,
            username: e?.roadmap?.users_permissions_user?.username,
            firstname: e?.roadmap?.users_permissions_user?.firstname,
            lastname: e?.roadmap?.users_permissions_user?.lastname,
            roadmapId: e?.roadmap?.id,
            createdAt: e.createdAt,
            renewal: e?.roadmap?.prev_roadmap?.key,
          })),
        );
      })
      .catch((err) => message.error("خطا در دریافت لیست گزارشات مانیتور"));
  };

  const filtersBeautify = (fData) => {
    return {
      ...(fData.firstname?.at(0) ? { firstname: fData.firstname?.at(0) } : {}),
      ...(fData.username?.at(0) ? { username: fData.username?.at(0) } : {}),
      ...(fData.lastname?.at(0) ? { lastname: fData.lastname?.at(0) } : {}),
      ...(fData.product?.at(0) ? { productCode: fData.product?.at(0) } : {}),
    };
  };

  return (
    <>
      <DataTable
        recordsCount={pagination?.total}
        dynamicPagination
        id="OperatorsReport"
        filtersBeautify={filtersBeautify}
        dataSource={data}
        setDataSource={setData}
        columns={columns}
        permissionsPrefix="flags"
        reload={loadData}
        recordCreatorDisabled
        header={{
          title: (
            <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
              <span>نظرات میانه مسیر</span>
            </div>
          ),
          avatar: { icon: <PieChartOutlined />, size: "large" },
        }}
      />
    </>
  );
};

export default VoteReport;
